<template>
  <div>
    <b-row v-for="(layoutRow, rowIndex) in layout" :key="rowIndex">
      <b-col v-for="(col, colIndex) in layoutRow.row" :key="colIndex" v-bind="colProps(col)">
        <layout-renderer v-if="col.row" :layout="nestedLayout(col)">
          <template #field="scope">
            <slot name="field" v-bind="scope" />
          </template>
        </layout-renderer>
        <slot v-else-if="col.key" name="field" v-bind="{ fieldKey: col.key }" />
        <template v-else-if="col.keys">
          <div v-for="(item, itemIndex) in col.keys" :key="itemIndex">
            <slot v-if="typeof item === 'string'" name="field" v-bind="{ fieldKey: item }" />
            <layout-renderer v-else :layout="nestedLayout(item)">
              <template #field="scope">
                <slot name="field" v-bind="scope" />
              </template>
            </layout-renderer>
          </div>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * Renderer recursivo de layout-como-datos (MOOV-5200), compartido por forms y filtros.
 *
 * Esquema: [{row: [col, ...]}, ...] donde cada col es
 *   {span?, key}            una hoja (campo), delegada al scoped slot #field="{fieldKey}"
 *   {span?, keys: [...]}    items apilados; cada item puede ser un string (hoja),
 *                           {span, keys} (sub-grilla lado a lado) o {row: [...]} (recursivo)
 *   {row: [...]}            filas anidadas
 *
 * span es responsive: un número mapea a cols de <b-col>; un objeto {cols?, sm?, md?, lg?, xl?}
 * pasa solo los breakpoints presentes; ausente equivale a cols="12".
 * El renderer no conoce tipos de campo: el consumidor pone el control en el slot.
 */
export default {
  name: 'LayoutRenderer',
  props: {
    layout: {
      type: Array,
      required: true
    }
  },
  methods: {
    colProps (col) {
      const span = col.span
      if (span === undefined || span === null) {
        return { cols: 12 }
      }
      if (typeof span === 'object') {
        const props = {}
        for (const breakpoint of ['cols', 'sm', 'md', 'lg', 'xl']) {
          if (span[breakpoint] !== undefined && span[breakpoint] !== null) {
            props[breakpoint] = span[breakpoint]
          }
        }
        return props
      }
      return { cols: span }
    },
    nestedLayout (node) {
      if (node.row) {
        return [{ row: node.row }]
      }
      const span = node.span || Math.floor(12 / node.keys.length)
      return [
        {
          row: node.keys.map(key => (typeof key === 'string' ? { span, key } : { span, ...key }))
        }
      ]
    }
  }
}
</script>
